import { normal_button_theme } from 'framework/button/constants';
import { field_dark_theme } from 'framework/field/constants';
import { SwitchTheme } from 'framework/Switch/types';
import { font_theme } from 'framework/theme/constants/font';

export const switch_theme: Pick<SwitchTheme, 'general'> = {
  general: {
    font_family: font_theme.general.font_family,
    font_size: font_theme.general.font_size_small,
  },
};

export const switch_dark_theme: SwitchTheme = {
  general: switch_theme.general,
  background: {
    normal: field_dark_theme.background.normal,
    active: normal_button_theme.background.active,
    hover: field_dark_theme.background.hover,
    disabled: field_dark_theme.background.disabled,
  },
};
